import { CreateMedicalServiceEtlFields } from './CreateMedicalServiceEtlField';

export const CreateMedicalServiceEtlFieldsOlos = () => {
  return <CreateMedicalServiceEtlFields contextType="OLOS" />;
};

export default CreateMedicalServiceEtlFieldsOlos;
